import _Object$assign from 'babel-runtime/core-js/object/assign';
import _Object$entries from 'babel-runtime/core-js/object/entries';
import _getIterator from 'babel-runtime/core-js/get-iterator';
import _slicedToArray from 'babel-runtime/helpers/slicedToArray';

import 'echarts/lib/chart/line';
function deepAssign(a, b) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = _getIterator(_Object$entries(b)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _ref = _step.value;

      var _ref2 = _slicedToArray(_ref, 2);

      var key = _ref2[0];
      var value = _ref2[1];

      if (!b[key] || !(b[key] instanceof Object) || !(value instanceof Object) || Array.isArray(b[key]) && Array.isArray(value)) {
        a[key] = value;
      } else {
        deepAssign(a[key], b[key]);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return a;
}
export default {
  props: {
    customOptions: Object,
    loading: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    this.$refs.echarts.showLoading();
  },

  computed: {
    computedOptions: function computedOptions() {
      var baseConfig = {

        title: {
          text: '折线图堆叠',
          textStyle: {
            fontSize: 12
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {
          data: ['邮件营销', '联盟广告', '视频广告', '直接访问', '搜索引擎'],
          right: 30
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category'
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, '100%'],
          splitLine: {
            show: false
          },
          axisLabel: {}
        },
        series: [{
          name: '邮件营销',
          type: 'line',
          stack: 'all',
          data: [120, 132, 101, 134, 90, 230, 210]
        }, {
          name: '联盟广告',
          type: 'line',
          stack: 'all',
          data: [220, 182, 191, 234, 290, 330, 310]
        }]

      };
      var config = deepAssign(baseConfig, _Object$assign({}, this.customOptions));
      return config;
    }
  },
  watch: {
    loading: function loading(val) {
      if (!val) {
        this.$refs.echarts.hideLoading();
      } else {
        this.$refs.echarts.showLoading();
      }
    }
  }
};